import React from 'react';
import { ListItemButton, ListItemText, Typography, ListItemSecondaryAction } from '@mui/material';
import { Link } from 'react-router-dom';
import { get } from 'global/lib/lodash';
import moment from 'moment';
import { getStatus } from 'global/utils/edition';
import { uppercaseFirstAll } from 'global/utils';

export function EditionListItem(props) {
  const { item } = props;

  const content = {
    ...item,
    id: get(item, 'id', ''),
    title: get(item, 'name', ''),
    modifiedDate: moment(get(item, 'updatedAt')).format('L'),
    status: getStatus(item),
  };

  // PFM-2689: in modal/picker mode (onClick provided) the row must select in-place
  // and never client-side navigate. Omit `to` entirely so MUI v9 ListItemButton has
  // no route to follow; only render as a router Link in normal Library mode.
  const linkProps = props.onClick ? {} : { component: Link, to: `/library/${content.id}` };

  return (
    <ListItemButton {...linkProps} onClick={props.onClick ? (e) => props.onClick(content, e) : undefined} key={content.id}>
      <ListItemText
        primary={
          <Typography component="span" fontWeight="bold">
            {content.title}
          </Typography>
        }
        slotProps={{ secondary: { component: 'div' } }}
        secondary={<Typography>{content.modifiedDate}</Typography>}
      />
      <ListItemSecondaryAction>
        <Typography fontWeight="bold">{`${uppercaseFirstAll(content.status.title)}`}</Typography>
      </ListItemSecondaryAction>
    </ListItemButton>
  );
}
